<template>
  <div :class="!edit&&IS_MOBILE?'img-swiper-100':'img-swiper'">
    <div class="swiper-upload" @click="upload" @change="handleFile" v-if="edit">
      <input type="file" :id="updateAvatar" style="display:none" accept="image/png, image/jpeg, image/jpg">
      <i class="el-icon-plus add-plus"></i>
    </div>
    <div :class="[IS_MOBILE&&edit?'m-swiper-img-content':'swiper-img-content']" v-loading="loading">
       <swiper class="swiper" ref="swiper" :options="swiperOption">
        <swiper-slide v-for="(item,key) in imgList" :key="key">
          <div class="img-content">
            <el-image
                class="img-content-el-img"
                :src="item"
                :preview-src-list="imgList">
              </el-image>
            <i class="el-icon-error img-content-colse" v-if="edit" @click="deleteImg(key)"></i>
          </div>
        </swiper-slide>
        <div class="swiper-button-prev swiper-button-grey" slot="button-prev"></div>
        <div class="swiper-button-next swiper-button-grey" slot="button-next"></div>
      </swiper>
    </div>
  </div>
</template>

<script>
// swiper 滑动组件----pc移动混用
// 可以设置上传显示不显示edid字段 ui完成
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import './swiper3.1.3.css'
import { postAction } from '@/api/manage'
export default {
  components: {
    swiper,
    swiperSlide
  },
  props: {
    edit: {
      default: true,
      type: Boolean
    },
    obj: {
      default: () => { return {} },
      type: Object
    },
    salesCompare: {
      default: function() {},
      type: Function
    },
    imgListMessage: {
      default: () => { return [] },
      type: Array
    }
  },
  data() {
    return {
      IS_MOBILE: false,
      uploadUrl: '',
      updateAvatar: '',
      loading: false,
      imgList: [],
      swiperOption: {
        slidesPerView: this.IS_MOBILE ? 2 : 8,
        spaceBetween: this.IS_MOBILE ? 0 : 25,
        direction: 'horizontal',
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  created() {
    this.uploadUrl = process.env.API_URL + 'common/service_orders'
    if (this.edit === false && this.IS_MOBILE) {
      this.swiperOption.slidesPerView = 3
      let imgSwiper = document.querySelector('.img-swiper')
      imgSwiper.style.width = '100% !important'
    }
    if (JSON.stringify(this.obj) !== '{}') {
      this.imgList = this.obj.imgList || []
      this.updateAvatar = `updateAvatar${this.obj.skuId}`
    } else {
      this.imgList = this.imgListMessage
      this.updateAvatar = 'updateAvatar'
    }
  },
  methods: {
    handleFile(e) {
      let file = e.target.files[0]
      let formData = new FormData()
      formData.append('file', file)
      this.loading = true
      postAction('/common/service-orders', formData).then((res) => {
        if (res.code === 200) {
          // 上传成功后
          this.imgList.push(res.result)
          this.loading = false
          this.obj.imgList = this.imgList
          this.salesCompare(this.obj)
        } else {
          this.loading = false
          this.$message.error(res.message)
        }
      })
    },
    upload() {
      if (this.loading) { return false }
      if (this.imgList.length > 10) {
        this.$message.error('maxLeng is 10')
      }
      if (this.maxLength !== 10 && this.imgList.length >= 31) {
        this.$message.error('maxLeng is 30')
        return false
      }
      document.getElementById(this.updateAvatar).click()
    },
    deleteImg(key) {
      this.imgList.splice(key, 1)
      this.obj.imgList = this.imgList
      this.salesCompare(this.obj, this.imgList.length === 0 ? 'delete' : 'add')
    }
  }
}
</script>

<style lang="less" scoped>

@media screen and (min-width: 375px) and (max-width: 1024px){
.img-swiper{
    width: 100%;
  }
  // .swiper-img-content{
  // width: 100% !important;
  // }
}
@media screen and (min-width: 1400px){
  .img-swiper{
    width: 900px;
  }
}
.m-swiper-img-content{
  width: 70%;
}
.img-swiper-100{
  max-width: 100% !important;
  .swiper-img-content{
    max-width: 100% !important;
  }
}
.swiper-upload {
  width: 95px;
  height: 95px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  border: 1px solid #5D5D5D;
  background: #ffffff;
  cursor: pointer;
  margin-right: 10px;
  .add-plus{
    font-size: 22px;
    color: #8F8F8F;
  }
}

/deep/ .swiper-container{
  width: 100%;
}

.img-swiper{
  display: flex;
}
.swiper-img-content{
  width: 800px;
  // padding-left: 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  // margin-left: 20px;
}
.swiper{
  .swiper-button-grey{
    background-size: 50% 50%
  }
  .img-content{
    width: 95px;
    height: 95px;
    // background: #e1e1e1;
    display: flex;
    justify-content: right;
    position: relative;
    box-sizing: border-box;
    .img-content-colse{
      position: absolute;
      font-size: 18px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/order/service-order/components/img-swiper.vue